import React from "react";
import styled from "styled-components";

export default function Footer() {
  return (
    <Wrapper>
      <p>Copyright © 2019 CA BASE CAMP 2019.</p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
  font-size: 12px;
  line-height: 1;
  padding: 60px 0;
`;
